import Vue from 'vue';
import newsTransformer from './../../transformers/news';

const success = (news, resolve) => {
  resolve(newsTransformer.fetch(news));
};

const failed = (errors, reject) => {
  reject(newsTransformer.fetch(errors));
};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http
      .get(`news/${id}`)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/news/show.js